import defaultResultsState from "./defaultResultsState";

export const results = {
    namespaced: true,
    state: defaultResultsState(),
    getters: {
        getQuestionById: (state) => (id) => {
            return state.questions.find(question => question.id === id);
        },
    },
    mutations: {
        initialiseStore(state) {
            if(sessionStorage.getItem('results') && sessionStorage.getItem('results') !== 'undefined') {
                Object.assign(state, JSON.parse(sessionStorage.getItem('results')));
            }
        },
        commitStore(state) {
            Object.assign(state, state);
        },
        setQuestion(state, payload) {
            for(let index in state.questions) {
                if(state.questions[index].id === payload.id) {
                    state.questions[index].value = payload.value;
                }
            }
        },
        clearState(state) {
            Object.assign(state, defaultResultsState());
        }
    }
};
